export default function RemisesFinAnneeConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('remises.fin.annee');
}

RemisesFinAnneeConfiguration.$inject = ['$translatePartialLoaderProvider'];
